import { render, staticRenderFns } from "./TheAutoRankingPreferenceTh.vue?vue&type=template&id=140023fd&scoped=true&lang=pug&"
import script from "./TheAutoRankingPreferenceTh.vue?vue&type=script&lang=js&"
export * from "./TheAutoRankingPreferenceTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140023fd",
  null
  
)

export default component.exports